
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["compress","decompress"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "6964c383320c58ae8518.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			